import { Icons, FormButton, FormButtonProps } from '@monoimin/atoms';

import { getButtonIconAndText } from './index';

export function RenderButton(props: FormButtonProps) {
  //из текста кнопки получаем название иконки и текст кнопки бе названии иконки
  const { text, iconName } = getButtonIconAndText(props.children as string);
  return (
    <FormButton {...props} type='submit'>
      {text}
      {iconName && <Icons icon={iconName} isInteractive />}
    </FormButton>
  );
}
